const actions = {
    SUBSCRIPTION_READ_REQUEST: 'SUBSCRIPTION_READ_REQUEST',
    SUBSCRIPTION_READ_SUCCESS: 'SUBSCRIPTION_READ_SUCCESS',
    SUBSCRIPTION_READ_FAILURE: 'SUBSCRIPTION_READ_FAILURE',
    SUBSCRIPTION_CREATE_REQUEST: 'SUBSCRIPTION_CREATE_REQUEST',
    SUBSCRIPTION_CREATE_SUCCESS: 'SUBSCRIPTION_CREATE_SUCCESS',
    SUBSCRIPTION_CREATE_FAILURE: 'SUBSCRIPTION_CREATE_FAILURE',
    SUBSCRIPTION_SWITCH_REQUEST: 'SUBSCRIPTION_SWITCH_REQUEST',
    SUBSCRIPTION_SWITCH_SUCCESS: 'SUBSCRIPTION_SWITCH_SUCCESS',
    SUBSCRIPTION_SWITCH_FAILURE: 'SUBSCRIPTION_SWITCH_FAILURE',
    SUBSCRIPTION_DELETE_REQUEST: 'SUBSCRIPTION_DELETE_REQUEST',
    SUBSCRIPTION_DELETE_SUCCESS: 'SUBSCRIPTION_DELETE_SUCCESS',
    SUBSCRIPTION_DELETE_FAILURE: 'SUBSCRIPTION_DELETE_FAILURE',
    SUBSCRIPTION_RESUME_REQUEST: 'SUBSCRIPTION_RESUME_REQUEST',
    SUBSCRIPTION_RESUME_SUCCESS: 'SUBSCRIPTION_RESUME_SUCCESS',
    SUBSCRIPTION_RESUME_FAILURE: 'SUBSCRIPTION_RESUME_FAILURE',
    SUBSCRIPTION_PAY_REQUEST: 'SUBSCRIPTION_PAY_REQUEST',
    SUBSCRIPTION_PAY_SUCCESS: 'SUBSCRIPTION_PAY_SUCCESS',
    SUBSCRIPTION_PAY_FAILURE: 'SUBSCRIPTION_PAY_FAILURE',
    SUBSCRIPTION_PAYMENT_METHOD_REQUEST: 'SUBSCRIPTION_PAYMENT_METHOD_REQUEST',
    SUBSCRIPTION_PAYMENT_METHOD_SUCCESS: 'SUBSCRIPTION_PAYMENT_METHOD_SUCCESS',
    SUBSCRIPTION_PAYMENT_METHOD_FAILURE: 'SUBSCRIPTION_PAYMENT_METHOD_FAILURE',
    SUBSCRIPTION_SET_PAYMENT_METHOD_ID: 'SUBSCRIPTION_SET_PAYMENT_METHOD_ID',
    SUBSCRIPTION_READ_CLIENT_SECRET_REQUEST: 'SUBSCRIPTION_READ_CLIENT_SECRET_REQUEST',
    SUBSCRIPTION_READ_CLIENT_SECRET_SUCCESS: 'SUBSCRIPTION_READ_CLIENT_SECRET_SUCCESS',
    SUBSCRIPTION_READ_CLIENT_SECRET_FAILURE: 'SUBSCRIPTION_READ_CLIENT_SECRET_FAILURE',
    SUBSCRIPTION_READ_COMPANY_CLIENT_SECRET_REQUEST: 'SUBSCRIPTION_READ_COMPANY_CLIENT_SECRET_REQUEST',
    SUBSCRIPTION_READ_COMPANY_CLIENT_SECRET_SUCCESS: 'SUBSCRIPTION_READ_COMPANY_CLIENT_SECRET_SUCCESS',
    SUBSCRIPTION_READ_COMPANY_CLIENT_SECRET_FAILURE: 'SUBSCRIPTION_READ_COMPANY_CLIENT_SECRET_FAILURE',
    SUBSCRIPTION_READ_INVOICES_REQUEST: 'SUBSCRIPTION_READ_INVOICES_REQUEST',
    SUBSCRIPTION_READ_INVOICES_SUCCESS: 'SUBSCRIPTION_READ_INVOICES_SUCCESS',
    SUBSCRIPTION_READ_INVOICES_FAILURE: 'SUBSCRIPTION_READ_INVOICES_FAILURE',
    SUBSCRIPTION_READ_EVENTS_REQUEST: 'SUBSCRIPTION_READ_EVENTS_REQUEST',
    SUBSCRIPTION_READ_EVENTS_SUCCESS: 'SUBSCRIPTION_READ_EVENTS_SUCCESS',
    SUBSCRIPTION_READ_EVENTS_FAILURE: 'SUBSCRIPTION_READ_EVENTS_FAILURE',
    SUBSCRIPTION_UPDATE_STORAGE_ADD_ON_REQUEST: 'SUBSCRIPTION_UPDATE_STORAGE_ADD_ON_REQUEST',
    SUBSCRIPTION_UPDATE_STORAGE_ADD_ON_SUCCESS: 'SUBSCRIPTION_UPDATE_STORAGE_ADD_ON_SUCCESS',
    SUBSCRIPTION_UPDATE_STORAGE_ADD_ON_FAILURE: 'SUBSCRIPTION_UPDATE_STORAGE_ADD_ON_FAILURE',
    SUBSCRIPTION_UPDATE_ADDON_PACKS_REQUEST: 'SUBSCRIPTION_UPDATE_ADDON_PACKS_REQUEST',
    SUBSCRIPTION_UPDATE_ADDON_PACKS_SUCCESS: 'SUBSCRIPTION_UPDATE_ADDON_PACKS_SUCCESS',
    SUBSCRIPTION_UPDATE_ADDON_PACKS_FAILURE: 'SUBSCRIPTION_UPDATE_ADDON_PACKS_FAILURE',
    SUBSCRIPTION_SET_MODAL_CURRENT_STEP: 'SUBSCRIPTION_SET_MODAL_CURRENT_STEP',
    SUBSCRIPTION_RESET_MODAL_CURRENT_STEP: 'SUBSCRIPTION_RESET_MODAL_CURRENT_STEP',
    SUBSCRIPTION_READ_SWITCH_PLAN_INFO_REQUEST: 'SUBSCRIPTION_READ_SWITCH_PLAN_INFO_REQUEST',
    SUBSCRIPTION_READ_SWITCH_PLAN_INFO_SUCCESS: 'SUBSCRIPTION_READ_SWITCH_PLAN_INFO_SUCCESS',
    SUBSCRIPTION_READ_SWITCH_PLAN_INFO_FAILURE: 'SUBSCRIPTION_READ_SWITCH_PLAN_INFO_FAILURE',
    SUBSCRIPTION_PREVIEW_INVOICE_REQUEST: 'SUBSCRIPTION_PREVIEW_INVOICE_REQUEST',
    SUBSCRIPTION_PREVIEW_INVOICE_SUCCESS: 'SUBSCRIPTION_PREVIEW_INVOICE_SUCCESS',
    SUBSCRIPTION_PREVIEW_INVOICE_FAILURE: 'SUBSCRIPTION_PREVIEW_INVOICE_FAILURE',
    SUBSCRIPTION_SET_BILLING_TEXT_INFO: 'SUBSCRIPTION_SET_BILLING_TEXT_INFO',
    SUBSCRIPTION_RESET_INVOICE_PREVIEW: 'SUBSCRIPTION_RESET_INVOICE_PREVIEW',
    SUBSCRIPTION_RESET: 'SUBSCRIPTION_RESET',
    SUBSCRIPTION_READ_BILLING_PROFILE_REQUEST: 'SUBSCRIPTION_READ_BILLING_PROFILE_REQUEST',
    SUBSCRIPTION_READ_BILLING_PROFILE_SUCCESS: 'SUBSCRIPTION_READ_BILLING_PROFILE_SUCCESS',
    SUBSCRIPTION_READ_BILLING_PROFILE_FAILURE: 'SUBSCRIPTION_READ_BILLING_PROFILE_FAILURE',
    SUBSCRIPTION_UPDATE_BILLING_PROFILE_REQUEST: 'SUBSCRIPTION_UPDATE_BILLING_PROFILE_REQUEST',
    SUBSCRIPTION_UPDATE_BILLING_PROFILE_SUCCESS: 'SUBSCRIPTION_UPDATE_BILLING_PROFILE_SUCCESS',
    SUBSCRIPTION_UPDATE_BILLING_PROFILE_FAILURE: 'SUBSCRIPTION_UPDATE_BILLING_PROFILE_FAILURE',

    read: () => ({
        type: actions.SUBSCRIPTION_READ_REQUEST,
    }),
    create: request => ({
        type: actions.SUBSCRIPTION_CREATE_REQUEST,
        request,
    }),
    switch: request => ({
        type: actions.SUBSCRIPTION_SWITCH_REQUEST,
        request,
    }),
    delete: () => ({
        type: actions.SUBSCRIPTION_DELETE_REQUEST,
    }),
    resume: () => ({
        type: actions.SUBSCRIPTION_RESUME_REQUEST,
    }),
    pay: () => ({
        type: actions.SUBSCRIPTION_PAY_REQUEST,
    }),
    updatePaymentMethod: request => ({
        type: actions.SUBSCRIPTION_PAYMENT_METHOD_REQUEST,
        request,
    }),
    setPaymentMethodId: paymentMethodId => ({
        type: actions.SUBSCRIPTION_SET_PAYMENT_METHOD_ID,
        paymentMethodId,
    }),
    readClientSecret: id => ({
        type: actions.SUBSCRIPTION_READ_CLIENT_SECRET_REQUEST,
        id,
    }),
    readCompanyClientSecret: id => ({
        type: actions.SUBSCRIPTION_READ_COMPANY_CLIENT_SECRET_REQUEST,
        id,
    }),
    readInvoices: payload => ({
        type: actions.SUBSCRIPTION_READ_INVOICES_REQUEST,
        payload,
    }),
    readEvents: payload => ({
        type: actions.SUBSCRIPTION_READ_EVENTS_REQUEST,
        payload,
    }),
    updateStorageAddon: request => ({
        type: actions.SUBSCRIPTION_UPDATE_STORAGE_ADD_ON_REQUEST,
        request,
    }),
    updateAddonPacks: (id, request) => ({
        type: actions.SUBSCRIPTION_UPDATE_ADDON_PACKS_REQUEST,
        id, // from GET /addon_packs
        request, // { type, quantity }
    }),
    setModalCurrentStep: step => ({
        type: actions.SUBSCRIPTION_SET_MODAL_CURRENT_STEP,
        step,
    }),
    resetModalCurrentStep: () => ({
        type: actions.SUBSCRIPTION_RESET_MODAL_CURRENT_STEP,
    }),
    readSwitchPlanInfo: () => ({
        type: actions.SUBSCRIPTION_READ_SWITCH_PLAN_INFO_REQUEST,
    }),
    previewInvoice: (request, previewType, metaData) => ({
        type: actions.SUBSCRIPTION_PREVIEW_INVOICE_REQUEST,
        request,
        previewType,
        metaData, // {  // isDummy, billingCycleBefore, billingCycleAfter, subtotalBefore, subtotalAfter, overrideInvoiceNow, overrideInvoiceNext }
    }),
    setBillingTextInfo: billingTextInfo => ({
        type: actions.SUBSCRIPTION_SET_BILLING_TEXT_INFO,
        billingTextInfo,
    }),
    resetInvoicePreview: () => ({
        type: actions.SUBSCRIPTION_RESET_INVOICE_PREVIEW,
    }),
    reset: () => ({
        type: actions.SUBSCRIPTION_RESET,
    }),
    readBillingProfile: () => ({
        type: actions.SUBSCRIPTION_READ_BILLING_PROFILE_REQUEST,
    }),
    updateBillingProfile: request => ({
        type: actions.SUBSCRIPTION_UPDATE_BILLING_PROFILE_REQUEST,
        request,
    }),
};
export default actions;
